// extracted by mini-css-extract-plugin
module.exports = {"aboutSection":"AboutSection_aboutSection__2RyoY","strong":"AboutSection_strong__Ekkm0"};